import { IconProps } from '@models/icons';

function FoodAIcon({ size, color, ...rest }: IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
            {...rest} >
            <circle cx="12" cy="12" r="12" fill={color}/>
            <path
                d="M8.65201 5.00018C7.18733 5.00018 5.99988 6.38223 5.99988 8.0871C5.99988 9.51057 6.82908 10.7056 7.95463 11.0626L7.78246 18.1304C7.78246 18.361 7.87407 18.5822 8.03715 18.7453C8.20022 18.9084 8.4214 19 8.65202 19C8.88264 19 9.10381 18.9084 9.26689 18.7453C9.42996 18.5822 9.52157 18.361 9.52157 18.1304L9.34941 11.0626C10.4755 10.7055 11.3042 9.51057 11.3042 8.0871C11.3041 6.38223 10.1167 5.00018 8.65201 5.00018Z"
                fill="white"/>
            <path
                d="M16.9347 8.62326H16.239V5.02173H15.2825V8.62326H14.5869V5.02173H13.4347V9.06534C13.4347 9.98513 14.1987 10.7653 15.0199 11.0536L14.8478 18.1304C14.8478 18.361 14.9394 18.5822 15.1024 18.7453C15.2655 18.9083 15.4867 19 15.7173 19C15.9479 19 16.1691 18.9083 16.3322 18.7453C16.4953 18.5822 16.5869 18.361 16.5869 18.1304L16.4144 11.0536C17.2361 10.7655 17.9999 9.98513 17.9999 9.06534V5.02173H16.9347V8.62326Z"
                fill="white"/>
        </svg>
    );
}

export default FoodAIcon;
